import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopDevPageArtStage from './primis/DesktopDevPageArtStage';
import DesktopDevPageStage728x90Fs from './freestar/DesktopDevPageStage728x90';
const DesktopDevPageStage728x90 = ({ safety ='off' , safetyState  })=>{
    const noVideo = useFlag('ads_devpage_display_top');
    if (noVideo) {
        return /*#__PURE__*/ React.createElement(DesktopDevPageStage728x90Fs, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopDevPageArtStage, {
        safety: safety,
        safetyState: safetyState
    });
};
DesktopDevPageStage728x90.displayName = 'DesktopDevPageStage728x90';
export default DesktopDevPageStage728x90;
